import DrawingCanvas from './DrawingCanvas'

export default DrawingCanvas
